interface ChatJobRecommendationItem {
  slug: string;
  title: string;
  companyName: string;
  companyLogo?: string;
  salary?: string;
  locations: { name: string }[];
  url?: string;
  type: string;
}

export const recommendationToJobItem = (rec: ChatJobRecommendationItem): ApiSchema<'JobItem'> => ({
  id: rec.slug,
  slug: rec.slug,
  title: rec.title,
  companyName: rec.companyName,
  companyLogo: rec.companyLogo || undefined,
  salary: rec.salary || undefined,
  locations: rec.locations.map((location) => ({ name: location.name })),
  active: rec.type !== 'lead',
  state: rec.type === 'lead' ? 'passive' : 'active',
  hasOwnApplyUrl: rec.type === 'lead',
  ownApplyUrl: rec.type === 'lead' ? rec.url : undefined,
});
